import CustomScroll from 'components/CustomScroll';
import EditQuantity from 'components/cart-item-editor/EditQuantity';
import ModifierBreadcrumb from 'components/cart-item-editor/ModifierBreadcrumb';
import ModifierGroups from 'components/cart-item-editor/ModifierGroups';
import SpecialInstructions from 'components/cart-item-editor/SpecialInstructions';
import { TODO } from 'utils/Types';
import { ItemInnerContent, LockedCartWarning, Spacer, RecommendationCarouselWrapper } from '../styles';
import RecommendationCarousel from '../RecommendationCarousel';
import { WaypointContent } from './Waypoint';

const ItemDetailsContent = ({
  hasImage,
  isViewingCartItem,
  isNew,
  submitPressed,
  addHTMLElementError,
  recommendedItems,
  menuItem,
  locationStore,
  checkoutStore,
  cartItem,
  selectedCart,
  setShowFixedHeader,
  isMobile,
  modalTitleRef,
}: {
  hasImage: boolean;
  isViewingCartItem: boolean;
  isNew: boolean;
  submitPressed: boolean;
  addHTMLElementError: TODO;
  recommendedItems: TODO[];
  menuItem: TODO;
  locationStore: TODO;
  checkoutStore: TODO;
  cartItem: TODO;
  selectedCart: TODO;
  setShowFixedHeader: TODO;
  isMobile: boolean;
  modalTitleRef: React.RefObject<HTMLDivElement>;
}) => (
  <ItemInnerContent hasImage={hasImage} enabledCheckout={locationStore.enable_checkout}>
    <CustomScroll>
      {!checkoutStore.isAllowedToEditItem(cartItem) && (
        <LockedCartWarning
          message={`${selectedCart.cartOwner.name} has locked the order. No more edits can be made to items at this time.`}
          type="warning"
        />
      )}
      <WaypointContent
        modalTitleRef={modalTitleRef}
        isMobile={isMobile}
        menuItem={menuItem}
        setShowFixedHeader={setShowFixedHeader}
      />
      {/* When viewing nested modifiers, displays breadcrumbs back to the cartItem */}
      <ModifierBreadcrumb />
      <ModifierGroups />
      {isViewingCartItem && (
        <>
          <SpecialInstructions
            cartItem={cartItem}
            submitPressed={submitPressed}
            addHTMLElementError={addHTMLElementError}
          />
          {locationStore.enable_checkout && <EditQuantity cartItem={cartItem} isNew={isNew} />}
        </>
      )}
      {!!recommendedItems.length && (
        <>
          <Spacer />
          <RecommendationCarouselWrapper>
            <RecommendationCarousel fromCart={false} referringItem={menuItem} recommendedItems={recommendedItems} />
          </RecommendationCarouselWrapper>
        </>
      )}
    </CustomScroll>
  </ItemInnerContent>
);

export default ItemDetailsContent;
